import { render } from "./statuspage.vue?vue&type=template&id=699e7a2a&scoped=true"
import script from "./statuspage.vue?vue&type=script&lang=js"
export * from "./statuspage.vue?vue&type=script&lang=js"

import "./statuspage.vue?vue&type=style&index=0&id=699e7a2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-699e7a2a"]])

export default __exports__